import React from 'react';

import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from '@newsela/angelou';
import {isNull, get, isEmpty} from 'lodash-es';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {
  clearExternalToolContext,
  requestExternalToolContext,
  setExternalToolContext,
} from 'modulesV2/actions';
import {getExternalToolContext} from 'modulesV2/selectors';
import {
  requestClassrooms
} from 'static/three-oh/src/modules/actions/classroomActions';
import {
  classroomSelectors,
} from 'static/three-oh/src/modules/selectors';

import styles from './ExternalToolIndicatorStyles.scss';


class ExternalToolIndicatorContainer extends React.Component {
  static propTypes = {
    additionalClassName: PropTypes.string,
    context: PropTypes.object,
    user: PropTypes.object,
    clearContext: PropTypes.func.isRequired,
    setExternalToolContext: PropTypes.func.isRequired,
    requestExternalToolContext: PropTypes.func.isRequired,
    requestClassrooms: PropTypes.func.isRequired,
    selectedClass: PropTypes.object,
    location: PropTypes.object,
    areClassroomsLoading: PropTypes.bool.isRequired,
    classrooms: PropTypes.array,
    nonReactPage: PropTypes.bool
  };

  componentDidMount() {
    // This is required to populate redux store on non-react pages
    const url = window.location.href;
    // Angular pages use long outdated /#/ navigation so we cannot leverage
    // built in 'window.location.search' and have to resort to regex matching,
    // In case you are wondering, no, `withRouter` won't work either.
    const search = url.substring(url.indexOf('?'));
    const queryParams = new URLSearchParams(search);
    const externalTool = queryParams.get('externalTool');
    if (externalTool) {
      this.props.setExternalToolContext({
        courseTitle: queryParams.get('courseTitle'),
        provider: externalTool,
        courseId: queryParams.get('courseId'),
        classroomSourceId: queryParams.get('classroomSourceId'),
        externalLtiAssignmentId: queryParams.get('externalLtiAssignmentId'),
        message: queryParams.get('message'),
        action: queryParams.get('action'),
      });
    }
    this.props.requestExternalToolContext();
    const shouldFetchClassrooms = !this.props.areClassroomsLoading && isEmpty(this.props.classrooms);
    if (shouldFetchClassrooms) {
      this.props.requestClassrooms(this.props.user.id);
    }
  }

  render() {
    const {context, clearContext, selectedClass} = this.props;
    const isCanvasApp = window.location.pathname.startsWith('/apps/canvas');
    if (isNull(context) || isCanvasApp) {
      return null;
    }
    const courseTitle = get(selectedClass, 'name', context.courseTitle);
    const message = context.message || (<span>
      You're creating an assignment for your <strong>“{courseTitle}”</strong> {context.provider} class
    </span>);

    const nonReactClass = this.props.nonReactPage ? styles.nonReactContainer : '';
    const additionalClassName = this.props.additionalClassName ? this.props.additionalClassName : '';

    const classNames = `${styles.container} ${nonReactClass} ${additionalClassName}`.trim();
    return (
      <div
        className={classNames}
        data-qa-selector="external_tool_indicator"
      >
        <div className={styles.label}>
          {message}
        </div>
        <Button
          /* AUTOGENERATED TODO: update angelou to new flavor.
            see https://github.com/newsela/angelou/blob/main/src/components/Button/README.md#MIGRATION
            for migration guide. */
          legacy_flavor={Button.legacy_flavor.incognito}
          __classNameFor={{
            root: styles.exitButton
          }}
          onClick={clearContext}
        >
          <FontAwesomeIcon icon={faSignOutAlt}/>
          Exit
        </Button>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const courseId = get(getExternalToolContext(state), 'courseId');
  const selectedClass = classroomSelectors.getClassroomById(state, courseId);
  return {
    context: getExternalToolContext(state),
    areClassroomsLoading: classroomSelectors.isClassroomApiCallInProgress(state),
    classrooms: classroomSelectors.getClassrooms(state),
    selectedClass,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearContext: bindActionCreators(clearExternalToolContext, dispatch),
    requestExternalToolContext: bindActionCreators(requestExternalToolContext, dispatch),
    requestClassrooms: bindActionCreators(requestClassrooms, dispatch),
    setExternalToolContext: bindActionCreators(setExternalToolContext, dispatch),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ExternalToolIndicatorContainer);
